@if (open() && view(); as v) {
  <div
    class="detail-popover"
    #popoverEl
    [style.left.px]="left()"
    [style.top.px]="top()"
    role="dialog"
    aria-label="Feedback detail"
  >
    <div class="pop-head">
      <div class="h-top">
        <span class="num-pill">#{{ v.number }}</span>
        @if (v.category) {
          <span class="cat-chip">{{ v.category }}</span>
        }
      </div>
      <div class="h-element">{{ v.element }}</div>
      <div class="h-actions">
        @if (loggedIn() && openInAppUrl()) {
          <a class="open-ext" [href]="openInAppUrl()" target="_blank" rel="noopener" aria-label="Open in feedback app" title="Open in feedback app">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></svg>
          </a>
        }
        <button class="close-x" type="button" aria-label="Close" (click)="close.emit()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
        </button>
      </div>
    </div>

    <div class="pop-subhead">
      <div class="reporter">
        <div class="avatar">{{ v.initials }}</div>
        <div class="who">
          <div class="n">{{ v.reporterName || 'Unknown' }}</div>
          @if (v.reporterEmail) {
            <div class="e">{{ v.reporterEmail }}</div>
          }
        </div>
      </div>
      <fb-status-chip [statuses]="statuses" [current]="v.status" (statusChange)="onStatusChange($event)" />
    </div>

    <div class="pop-scroll">
      <div class="pop-section">
        <div class="label">Observation</div>
        <div class="observation">{{ v.observation || 'No observation provided.' }}</div>
      </div>

      @if (v.recommendation) {
        <div class="pop-section">
          <div class="label rec">Recommendation</div>
          <div class="observation rec">{{ v.recommendation }}</div>
        </div>
      }

      @if (v.screenshotUrl) {
        <div class="pop-section">
          <div class="label">Screenshot</div>
          <a class="pop-shot" [href]="v.screenshotUrl" target="_blank" rel="noopener" aria-label="Open screenshot in new tab">
            <img class="shot-img" [src]="v.screenshotUrl" alt="Feedback screenshot" />
            <span class="shot-open-hint">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></svg>
              Open full size
            </span>
            <span class="shot-tag">pin-{{ v.number }}.png</span>
          </a>
        </div>
      }

      <div class="pop-section">
        <div class="meta-grid">
          <div class="cell">
            <div class="k">Device</div>
            <div class="v">
              @switch (v.device) {
                @case ('mobile') {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="2" width="10" height="20" rx="2" /><path d="M11 18h2" /></svg>
                }
                @case ('tablet') {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" /><path d="M11 18h2" /></svg>
                }
                @default {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="13" rx="2" /><path d="M8 21h8M12 17v4" /></svg>
                }
              }
              {{ v.deviceLabel }}
            </div>
          </div>
          <div class="cell">
            <div class="k">Source</div>
            <div class="v">
              <span class="type-badge t-{{ v.source }}">
                @if (v.source === 'AI') {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v4" /><rect x="4" y="6" width="16" height="13" rx="2.5" /><circle cx="9" cy="12.5" r="1.2" fill="currentColor" stroke="none" /><circle cx="15" cy="12.5" r="1.2" fill="currentColor" stroke="none" /><path d="M9.5 16h5" /><path d="M2 13v3" /><path d="M22 13v3" /></svg>
                  AI
                } @else {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
                  User
                }
              </span>
            </div>
          </div>
          <div class="cell">
            <div class="k">Reported</div>
            <div class="v">{{ v.reported }}</div>
          </div>
          <div class="cell">
            <div class="k">Operating system</div>
            <div class="v">{{ v.os }}</div>
          </div>
          <div class="cell">
            <div class="k">Browser</div>
            <div class="v">{{ v.browser }}</div>
          </div>
        </div>
      </div>

      @if (v.assets.length) {
        <div class="pop-section">
          <div class="label assets-label">Assets<span class="assets-count">{{ v.assets.length }}</span></div>
          <div class="assets">
            @for (asset of v.assets; track asset.url) {
              <a class="asset" [href]="asset.url" target="_blank" rel="noopener noreferrer" [title]="'Open ' + asset.name + ' in new tab'">
                <span class="asset-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>
                </span>
                <span class="asset-name">{{ asset.name }}</span>
                <svg class="asset-ext" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></svg>
              </a>
            }
          </div>
        </div>
      }

      <div class="pop-section">
        <div class="label">Discussion</div>
        <fb-comment-thread
          [comments]="comments()"
          [loading]="commentsLoading()"
          [posting]="commentPosting()"
          (post)="commentPost.emit($event)"
        />
      </div>
    </div>
  </div>
}
